import createFetchDuck from '../../util/genericEntityDuck';

export const storeKey = 'beatboxFlows';
const duck = createFetchDuck('HEARTBEAT', storeKey, 'id', 'heartbeat');

export default duck;
export const { creators, reducer, types, selectors } = duck;
